
import { defineComponent, computed } from 'vue'
import store from '@/store'
import ImagesTable from '@/components/IndexTemplates/ImagesTable.vue'
import BaseTablePanel from '@/components/Shared/BaseTablePanel.vue'

export default defineComponent({
  components: {
    ImagesTable,
    BaseTablePanel
  },
  emits: ['paginate', 'deleteImage'],
  setup() {
    const loading = computed(() => store.state.images.loading)
    return { loading }
  }
})
